import type { ClientConfiguration } from "../types/clientConfig";

export function resolveAthleteClientConfiguration(
  athlete: { _id: string },
  configsByClientId: Record<string, ClientConfiguration> | undefined | null
): ClientConfiguration | null {
  return configsByClientId?.[athlete._id] ?? null;
}
